<template>
  <V5Layout :page="page">
    <V5PageHead :title="t(`v5.nav.${page}`)" />
    <section class="v5-panel v5-plh" aria-labelledby="v5-plh-h">
      <h2 id="v5-plh-h">{{ t('v5.placeholder.title') }}</h2>
      <p>{{ t('v5.placeholder.body', { page: t(`v5.nav.${page}`) }) }}</p>
      <router-link class="v5-btn" :to="classic">{{ t('v5.placeholder.open_classic') }}</router-link>
      <small>{{ t(`v5.placeholder.audience_${V5_AUDIENCE}`) }}</small>
    </section>
  </V5Layout>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import V5Layout from '../V5Layout.vue';
import V5PageHead from '../components/V5PageHead.vue';
import { classicFor } from '../nav';
import { V5_AUDIENCE } from '../access';

// Stand-in for a page not rebuilt yet; each later PR swaps one of these for the real page.
const props = defineProps({ page: { type: String, required: true } });
const { t } = useI18n();
const classic = computed(() => classicFor(props.page));
</script>

<style scoped>
.v5-plh { display: grid; justify-items: start; gap: 10px; max-width: 560px; padding: 24px; }
.v5-plh h2 { margin: 0; font-size: var(--t-xl); font-weight: 600; }
.v5-plh p { margin: 0; color: var(--fg-2); }
.v5-plh small { color: var(--muted); font-size: var(--t-xs); }
</style>
